import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

export interface YouTubeSettings {
  youtubeUrl: string;
}

export interface ContactSettings {
  contactEmail: string;
  resumeEmail: string;
  donationEmail: string;
  contactPhone: string;
  contactAddress: string;
}

export interface SocialLink {
  platform: string;
  url: string;
}

export interface SocialSettings {
  links: SocialLink[];
}

export interface SiteSettingUpdateResponse {
  success: boolean;
  message: string;
}

export interface BrandingSettings {
  siteLogoImageId: number | null;
  defaultSiteLogoImageId: number | null;
  logoImageId: number | null;
  logoUrl: string | null;
  usingDefault: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class SiteSettingsService {
  getBranding(): Observable<BrandingSettings> {
    return this.http.get<BrandingSettings>(`${this.baseUrl}/branding`);
  }

  updateBranding(siteLogoImageId: number | null): Observable<SiteSettingUpdateResponse> {
    return this.http.put<SiteSettingUpdateResponse>(`${this.baseUrl}/branding`, { siteLogoImageId }, { withCredentials: true });
  }

  private readonly baseUrl =
    `${environment.apiUrl}/settings`;

  constructor(
    private readonly http: HttpClient
  ) {}


  // ------------------------------------------------------------
  // YOUTUBE

  // ------------------------------------------------------------

  getYouTube(): Observable<YouTubeSettings> {
    return this.http.get<YouTubeSettings>(
      `${this.baseUrl}/youtube`,
      {
        withCredentials: true
      }
    );
  }

  updateYouTube(
    youtubeUrl: string
  ): Observable<SiteSettingUpdateResponse> {
    return this.http.put<SiteSettingUpdateResponse>(
      `${this.baseUrl}/youtube`,
      {
        youtubeUrl
      },
      {
        withCredentials: true
      }
    );
  }


  // ------------------------------------------------------------
  // CONTACT SETTINGS

  // ------------------------------------------------------------

  getContactSettings(): Observable<ContactSettings> {
    return this.http.get<ContactSettings>(
      `${this.baseUrl}/contact`,
      {
        withCredentials: true
      }
    );
  }

  updateContactSettings(
    settings: ContactSettings
  ): Observable<SiteSettingUpdateResponse> {
    return this.http.put<SiteSettingUpdateResponse>(
      `${this.baseUrl}/contact`,
      settings,
      {
        withCredentials: true
      }
    );
  }


  // ------------------------------------------------------------
  // SOCIAL SETTINGS

  // ------------------------------------------------------------

  getSocialSettings(): Observable<SocialSettings> {
    return this.http.get<SocialSettings>(
      `${this.baseUrl}/social`,
      {
        withCredentials: true
      }
    );
  }

  updateSocialSettings(
    settings: SocialSettings
  ): Observable<SiteSettingUpdateResponse> {
    return this.http.put<SiteSettingUpdateResponse>(
      `${this.baseUrl}/social`,
      settings,
      {
        withCredentials: true
      }
    );
  }
}
